import { render, staticRenderFns } from "./StepBase.vue?vue&type=template&id=21a66027&scoped=true"
import script from "./StepBase.vue?vue&type=script&lang=js"
export * from "./StepBase.vue?vue&type=script&lang=js"
import style0 from "./StepBase.vue?vue&type=style&index=0&id=21a66027&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a66027",
  null
  
)

export default component.exports